var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgControlCmdToggleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2591 15.5682H0V14.5833H18.2591L14.3794 10.7036L15.0758 10L20.1515 15.0758L15.0758 20.1515L14.3794 19.4479L18.2591 15.5682Z",
    fill: "#4ED064"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.89325 5.56818H20.1523V4.58333H1.89325L5.77299 0.703599L5.07659 0L0.000827789 5.07576L5.07659 10.1515L5.77299 9.44792L1.89325 5.56818Z",
    fill: "#4ED064"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgControlCmdToggleIcon);
export default __webpack_public_path__ + "static/media/control-cmd-toggle-icon.a23eb7b514c413bb39c1da7333ffee07.svg";
export { ForwardRef as ReactComponent };